// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"i9-z"};